import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Export } from '../../../webcommon/common/Icons/Add-Circle.svg';
import { noop } from 'lodash';
import styles from '../GridHeaderButton.module.scss';

const NewRow = props => (
    <button
        className={ styles.gridHeaderButton }
        type="button"
        onClick={ props.addRow }
    >
        New Row <Export />
    </button>
);

NewRow.propTypes = {
    addRow: PropTypes.func
};

NewRow.defaultProps = {
    addRow: noop
};

export default NewRow;
